<div *ngIf="!isIE">
    <div *ngIf="!publicPage && !welcomePage && !searchPage && !childPublicPage && !feedbackForm && !docsFeedbackForm && !secondDocsFeedbackForm">
        <cop-header (hideOtherCompsEmit)="getHideOtherComps=$event"></cop-header>
        <cop-public-latest-news *ngIf="!getHideOtherComps"></cop-public-latest-news>
        <customer-care-main *ngIf="searchResultsStatus" [hideOtherComps]="getHideOtherComps"></customer-care-main>
        <cop-search-results *ngIf="!searchResultsStatus && !getHideOtherComps"></cop-search-results>
        <cop-footer></cop-footer>
    </div>

    <div *ngIf="publicPage && !welcomePage && !feedbackForm && !docsFeedbackForm && !secondDocsFeedbackForm">
        <cop-public-header
            (codeVerifierEmit)="getCodeVerifier=$event"
            (codeChallengeEmit)="getCodeChallenge=$event"
            (hideOtherCompsEmit)="getHideOtherComps=$event">
        </cop-public-header>
        <cop-public-latest-news *ngIf="!getHideOtherComps"></cop-public-latest-news>
        <cop-public [hideOtherComps]="getHideOtherComps"
            [codeVerifier]="getCodeVerifier"
            [codeChallenge]="getCodeChallenge">
        </cop-public>
        <customer-care-main [hideOtherComps]="getHideOtherComps"></customer-care-main>
        <cop-public-footer></cop-public-footer>
    </div>

    <div *ngIf="searchPage && !feedbackForm && !docsFeedbackForm && !secondDocsFeedbackForm">
        <cop-searchpage-header></cop-searchpage-header>
        <cop-search-page></cop-search-page>
        <cop-public-footer> </cop-public-footer>
    </div>

    <div *ngIf="childPublicPage && !feedbackForm && !docsFeedbackForm && !secondDocsFeedbackForm">
        <cop-public-header></cop-public-header>
        <cop-public-latest-news></cop-public-latest-news>
        <cop-page-public></cop-page-public>
        <cop-public-footer> </cop-public-footer>
    </div>

    <div *ngIf="feedbackForm && !docsFeedbackForm && !secondDocsFeedbackForm">
        <cop-feedback-form></cop-feedback-form>
    </div>

    <div *ngIf="!feedbackForm && docsFeedbackForm && !secondDocsFeedbackForm">
        <cop-docs-feedback-form></cop-docs-feedback-form>
    </div>

    <div *ngIf="!feedbackForm && !docsFeedbackForm && secondDocsFeedbackForm">
        <cop-docs-second-feedback-form></cop-docs-second-feedback-form>
    </div>
</div>
